import { Fragment, PropsWithChildren, ReactElement } from 'react';

import { reactToastifyDefaultConfig } from '@changegps/horizon-component-library';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';
import '@changegps/horizon-component-library/dist/style.css';

export const ToastProvider = (props: PropsWithChildren): ReactElement => {
  return (
    <Fragment>
      <ToastContainer {...reactToastifyDefaultConfig} />
      {props.children}
    </Fragment>
  );
};

// import { Fragment, PropsWithChildren } from 'react';

// import { reactToastifyDefaultConfig } from '@changegps/horizon-component-library';
// import { createPortal } from 'react-dom';
// import { ToastContainer } from 'react-toastify';

// import 'react-toastify/dist/ReactToastify.min.css';
// import '@changegps/horizon-component-library/dist/style.css';

// export const ToastProvider = (props: PropsWithChildren) => {
//   return (
//     <Fragment>
//       {createPortal(
//         <ToastContainer {...reactToastifyDefaultConfig} />,
//         document.getElementById('toast-container')!,
//       )}
//       {props.children}
//     </Fragment>
//   );
// };
